(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-frequency-from', {
            parent: 'entity',
            url: '/med-frequency-from',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency From'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-froms.html',
                    controller: 'MedFrequencyFromController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-frequency-from-detail', {
            parent: 'entity',
            url: '/med-frequency-from/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency From'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-detail.html',
                    controller: 'MedFrequencyFromDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedFrequencyFrom', function($stateParams, MedFrequencyFrom) {
                    return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-frequency-from',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-frequency-from-detail.edit', {
            parent: 'med-frequency-from-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-from.new', {
            parent: 'med-frequency-from',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('med-frequency-from');
                });
            }]
        })
        .state('med-frequency-from.edit', {
            parent: 'med-frequency-from',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-dialog.html',
                    controller: 'MedFrequencyFromDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-from.delete', {
            parent: 'med-frequency-from',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-from/med-frequency-from-delete-dialog.html',
                    controller: 'MedFrequencyFromDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedFrequencyFrom', function(MedFrequencyFrom) {
                            return MedFrequencyFrom.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-from', null, { reload: 'med-frequency-from' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
